import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Row, Col } from 'reactstrap';
import Select, { components } from 'react-select';
import { Utils } from 'custom';
import {AdminAPI, AppointmentAPI} from "api";

const statusOptions = [
    { value: 'CANCELED', label: 'Annullato', className: 'status-closed' },
    { value: 'CONFIRMED', label: 'Completato', className: 'status-converted' }
];

const Option = (props) => (
    <components.Option {...props}>
        <div className={`custom-badge ${props.data.className}`}>{props.data.label}</div>
    </components.Option>
);

const SingleValue = (props) => (
    <components.SingleValue {...props}>
        <div className={`custom-badge ${props.data.className}`}>{props.data.label}</div>
    </components.SingleValue>
);

const GestAppointment = ({ appointment, onResolve }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [userRole, setUserRole] = useState('');

    useEffect(() => {
        const userData = Utils.getUserData();
        setUserRole(userData.role);
    }, []);

    const toggleModal = () => setModalOpen(!modalOpen);

    const handleSaveStatus = () => {
        AppointmentAPI.edit({id: appointment.id, status: selectedStatus.value}).then(() => {
            toggleModal();
            onResolve();
        }).catch(() => {
            global.SweetAlert.fire({
                icon: 'error',
                title: 'Si è verificato un errore :(',
                text: 'Purtroppo qualcosa è andato storto e non è stato possibile modificare lo stato dell\'appuntamento. Riprova più tardi.',
                customClass: {
                    confirmButton: 'btn btn-success'
                }
            });
        })
    };

    return (
        <>
            <span>
                <div className="custom-badge status-unassigned cursor-pointer" onClick={toggleModal}>Pianificato</div>
            </span>

            <Modal isOpen={modalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>Gestione Appuntamento</ModalHeader>
                <ModalBody>
                    {userRole === 'ADMIN' && (
                        <FormGroup>
                            <Label for="statusSelect">Stato appuntamento</Label>
                            <Select
                                id="statusSelect"
                                components={{ Option, SingleValue }}
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={setSelectedStatus}
                                placeholder="-- Seleziona stato --"
                            />
                        </FormGroup>
                    )}
                </ModalBody>
                <ModalFooter>
                    {userRole === 'ADMIN' && (
                        <Button
                            size="sm"
                            color="success"
                            onClick={handleSaveStatus}
                            disabled={!selectedStatus}
                        >
                            Salva <i className="mdi mdi-content-save" />
                        </Button>
                    )}

                    <Button color="secondary" size="sm" onClick={toggleModal}>
                        Chiudi
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default GestAppointment;
